import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "bind-container"
};
const _hoisted_2 = {
  class: "card"
};
const _hoisted_3 = {
  class: "card-content"
};
const _hoisted_4 = {
  key: 0,
  class: "user-info"
};
const _hoisted_5 = {
  class: "user-avatar"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "user-name"
};
const _hoisted_8 = {
  key: 1,
  class: "error-tip"
};
const _hoisted_9 = {
  class: "bind-form"
};
const _hoisted_10 = {
  class: "form-group"
};
const _hoisted_11 = {
  class: "input-with-icon"
};
const _hoisted_12 = ["disabled"];
const _hoisted_13 = {
  key: 0,
  class: "input-error"
};
const _hoisted_14 = ["disabled"];
const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[7] || (_cache[7] = _createElementVNode("div", {
    class: "card-header"
  }, [_createElementVNode("h2", null, "绑定手机号"), _createElementVNode("p", null, "完成绑定成为叶婆手作尊享会员")], -1)), _createElementVNode("div", _hoisted_3, [$setup.authStore.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
    src: $setup.authStore.userInfo.headimgurl || require('@/assets/images/logo.jpg'),
    alt: "用户头像"
  }, null, 8, _hoisted_6)]), _createElementVNode("div", _hoisted_7, "您好，" + _toDisplayString($setup.authStore.userInfo.nick_name), 1)])) : _createCommentVNode("", true), $setup.authStore.error ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_cache[3] || (_cache[3] = _createElementVNode("i", {
    class: "fas fa-exclamation-circle"
  }, null, -1)), _createTextVNode(" " + _toDisplayString($setup.authStore.error), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_cache[5] || (_cache[5] = _createElementVNode("label", null, "手机号码", -1)), _createElementVNode("div", _hoisted_11, [_cache[4] || (_cache[4] = _createElementVNode("i", {
    class: "fas fa-mobile-alt"
  }, null, -1)), _withDirectives(_createElementVNode("input", {
    type: "tel",
    placeholder: "请输入您的手机号码",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.phone = $event),
    maxlength: "11",
    disabled: $setup.authStore.isProcessing,
    onInput: _cache[1] || (_cache[1] = (...args) => $setup.validatePhone && $setup.validatePhone(...args))
  }, null, 40, _hoisted_12), [[_vModelText, $setup.phone]])]), $setup.phoneError ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString($setup.phoneError), 1)) : _createCommentVNode("", true)]), _createElementVNode("button", {
    class: "btn-primary",
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.handleBind && $setup.handleBind(...args)),
    disabled: $setup.authStore.isProcessing || !$setup.isPhoneValid
  }, [$setup.authStore.isProcessing ? (_openBlock(), _createElementBlock("span", _hoisted_15, [...(_cache[6] || (_cache[6] = [_createElementVNode("i", {
    class: "fas fa-spinner fa-spin"
  }, null, -1), _createTextVNode(" 绑定中... ", -1)]))])) : (_openBlock(), _createElementBlock("span", _hoisted_16, "立即绑定"))], 8, _hoisted_14)])])])]);
}